import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import * as stylex from '@stylexjs/stylex'

const CHIP_HEIGHT = 20
const CHIP_ROW_GAP = 4

export const SUBTITLE_CHIPS_TWO_ROWS_HEIGHT = CHIP_HEIGHT * 2 + CHIP_ROW_GAP

const styles = stylex.create({
  container: {
    overflow: 'hidden',
    alignContent: 'flex-start',
    height: SUBTITLE_CHIPS_TWO_ROWS_HEIGHT,
  },
  chipRoot: {
    maxWidth: '100%',
    minWidth: 0,
  },
  chipBody: {
    overflow: 'hidden',
    minWidth: 0,
  },
  chipLabel: {
    overflow: 'hidden',
    display: 'block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

interface SubtitleChipsRowProps {
  entryKey: string
  chips: string[]
}

/**
 * 商品卡 subtitle 區塊：chips 以 wrap 排列，容器高度固定為兩行，
 * 單一 chip 若內容寬度超過容器寬度，會被限制為容器寬度並 ellipsis。
 */
export const SubtitleChipsRow = ({ entryKey, chips }: SubtitleChipsRowProps) => {
  return (
    <HStack
      flexWrap="wrap"
      gap={1}
      rootStyle={styles.container}
    >
      {chips.map((chip, index) => (
        <Chip
          key={`${entryKey}_chip_${index}`}
          color="blueGrey"
          variant="square"
          size="small"
          rootStyle={styles.chipRoot}
          xStyles={{ body: styles.chipBody, labelText: styles.chipLabel }}
        >
          {chip}
        </Chip>
      ))}
    </HStack>
  )
}
